import type React from "react";
import { useTranslation } from "react-i18next";

import type { ITransaction } from "@/api/interfaces/transactionLayout";
import TransactionsList from "@/base/blocks/TransactionsBlock/TransactionsList";
import { H5, P } from "@/base/components/Global";
import { Col } from "@/base/components/Layout";
import { TRANSACTION_ICON } from "@/constants/blobIcons";
import { createUseStyles } from "@/theme";

const useStyles = createUseStyles(() => ({
  scrollArea: {
    width: "100%",
    maxHeight: 480,
    overflowY: "auto",
  },
}));

type Props = {
  transactions: ITransaction[];
  id?: string;
};

const PerkTransactions: React.FC<Props> = ({ transactions, id }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Col col={12} directionColumn fullWidth noHorizontalMargin id={id}>
      <Col col={12} directionColumn noMargin>
        <H5 prefixIcon={TRANSACTION_ICON} gray1>
          {t("gift_card_transactions_title")}
        </H5>
        <P gray3 small noMarginTop>
          {t("gift_card_transactions_subtitle")}
        </P>
      </Col>
      <Col
        col={12}
        directionColumn
        fullWidth
        noMargin
        className={classes.scrollArea}
      >
        <TransactionsList transactions={transactions} noMargin />
      </Col>
    </Col>
  );
};

export default PerkTransactions;
